const Vue = require('vue')

const { debounce } = require('sci/utils')

const DEFAULT_VALUE = Symbol('default')

const trace = (label, value, ...parameters) => {
    console.groupCollapsed(label);
    console.log(value, ...parameters);
    console.trace();
    console.groupEnd();
}

const isRTL = (maskName) => {
    switch (maskName) {
        case 'simplePercentage':
        case 'money':
        case 'meters':
        case 'double':
        case 'squareMeters': {
            return true
        }
        default:
            return false
    }
}

const filter = (maskName, value) => {
    if (typeof value === 'string') {
        value = value.trim()
    }

    // value can be false because unmaskedvalue can return false
    if (value === '' || value === undefined || value === null || value === false) {
        return null
    }

    switch (maskName) {
        case 'phone':
            return value.replace(/_/, '')
        default:
            return value
    }
}

const filterOrDefault = (maskName, value, defaultValue, nullable) => {
    if (typeof value === 'string') {
        value = value.trim()
    }

    // value can be false because unmaskedvalue can return false
    if (value === '' || value === undefined || value === null || value === false) {
        if (defaultValue === DEFAULT_VALUE) {
            switch (maskName) {
                case 'simplePercentage':
                case 'money':
                case 'meters':
                case 'squareMeters':
                case 'double':
                    return nullable ? null : 0
                default:
                    return null
            }
        }

        return defaultValue
    }

    switch (maskName) {
        case 'simplePercentage':
        case 'money':
        case 'meters':
        case 'squareMeters':
        case 'double': {
            if (typeof value === 'string') {
                const float = parseFloat(
                    String(value)
                        .replace(/\./g, '')
                        .replace(/,/g, '.')
                )

                if (isNaN(float)) {
                    return filter(maskName, null, defaultValue, nullable)
                }

                return float
            }

            return value
        }
        case 'phone':
            return value.replace(/_/, '')
        default:
            return value
    }
}

Vue.component('form-mask', {
    props: {
        label: {
            type: String
        },
        placeholder: {
            type: String,
            default: null
        },
        iconClass: {
            type: String,
            default: null
        },
        model: {
            twoWay: true,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        digits: {
            default: 2,
            type: Number
        },
        mask: {
            required: true,
            default: null,
            type: String
        },
        autofocus: {
            default: false
        },
        defaultValue: {
            default: DEFAULT_VALUE
        },
        onBlur: {
            type: Function,
            default: null
        },
        onKeyDown: {
            type: Function,
            default: null
        },
        hint: {
            type: String,
            default: null
        },
        name: {
            default: null
        },
        nullable: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            fieldId: '',
            fieldName: '',
            inputClass: null,
            realDefaultValue: null,
            maskedModel: null,
            internalModel: null,
            initialModel: null,
            controlledModel: null,
            touched: false,
            display: false,
            isSetup: false
        }
    },
    ready () {
        this.realDefaultValue = filterOrDefault(this.mask, null, this.defaultValue, this.nullable)

        this.fieldName = this.name || this._props.model.raw
        this.fieldId = this.fieldName.replace(/\./g, '-')

        // console.log('ready', this.fieldName, {
        //     mask: this.mask,
        //     model: this.model,
        //     defaultValue: this.defaultValue,
        //     nullable: this.nullable,
        //     realDefaultValue: this.realDefaultValue
        // })

        if (!this.placeholder) {
            this.placeholder = this.label
        }

        this.inputClass = ['form-control']

        if (this.large) {
            this.inputClass.push('input-lg')
        }

        if (this.iconClass === null) {
            switch (this.mask) {
                case 'money':
                    this.iconClass = 'fa fa-usd'
                    break
            }
        }

        this.bind()
    },

    methods: {
        hasLabel () {
            return !!this.label || this.$hasSlot('label')
        },
        hasAppend () {
            return this.$hasSlot('append')
        },
        holderClass () {
            return {
                'input-icon': this.iconClass
            }
        },
        inputHolderClass () {
            return {
                'input-icon': this.iconClass,
                'input-group': this.hasAppend()
            }
        },
        bind () {
            // const oldModel = this.model;
            // const oldInitialModel = this.initialModel;
            // const oldInternalModel = this.internalModel;
            // const oldControlledModel = this.controlledModel;
            // console.log('bind', this.fieldName, { oldModel, oldInitialModel, oldInternalModel, oldControlledModel })

            const self = this

            if (!self.$els.input) {
                return
            }

            self.isSetup = false

            self.boot(self.model)

            const maskParams = {
                clearMaskOnLostFocus: true,
                digits: self.digits
            }

            this.doMask()

            self.$els.input.value = this.model

            self._instance = Inputmask(self.mask, maskParams).mask(self.$els.input)

            self.$els.input.addEventListener('keydown', (evt) => {
                if (evt.which === 13) {
                    const oldValue = self._valueBeforeBlur
                    const newValue = self._instance.unmaskedvalue()

                    if (oldValue !== newValue) {
                        self.changed(newValue)
                    }
                }
                // console.log('focused', this.fieldName)

                // self._valueBeforeBlur = self._instance.unmaskedvalue()
            })

            self.$els.input.addEventListener('focus', () => {
                // console.log('focused', this.fieldName)

                self._valueBeforeBlur = self._instance.unmaskedvalue()
            })

            self.$els.input.addEventListener('blur', () => {
                // console.log('blurred', this.fieldName)

                const oldValue = self._valueBeforeBlur
                const newValue = self._instance.unmaskedvalue()

                if (oldValue !== newValue) {
                    self.changed(newValue)
                }
            })

            this.$nextTick(() => {
                this.isSetup = true
                if (this.autofocus) {
                    this.fakeInputFocused()
                }

            })
        },
        boot (initialValue) {
            // const oldModel = this.model;
            // const oldInitialModel = this.initialModel;
            // const oldInternalModel = this.internalModel;
            // const oldControlledModel = this.controlledModel;
            //
            // console.log("bootStart", this.fieldName, {
            //     initialValue,
            //     oldModel,
            //     oldInitialModel,
            //     oldInternalModel,
            //     oldControlledModel,
            // })

            this.touched = false
            this.initialModel = filterOrDefault(this.mask, initialValue, this.defaultValue, this.nullable)
            this.internalModel = filter(this.mask, initialValue)
            this.controlledModel = this.initialModel
            this.model = this.initialModel

            // console.log("bootEnd", this.fieldName, {
            //     initialValue,
            //     initialModel: this.initialModel,
            //     internalModel: this.internalModel,
            //     model: this.model,
            //     controlledModel: this.controlledModel,
            //     oldModel,
            //     oldInitialModel,
            //     oldInternalModel,
            //     oldControlledModel,
            // })
        },
        _onBlur (event) {
            if (this.onBlur) {
                this.onBlur(event)
            }
            this.display = false
        },
        _onKeyDown (event) {
            if (this.onKeyDown) {
                this.onKeyDown(event)
            }
        },
        getHint () {
            if (this.hint) {
                return this.hint
            }
        },
        doMask () {
            const stringInternalModel = String(this.internalModel)
            const stringRealDefaultValue = String(this.realDefaultValue)

            if (this.touched) {
                if (stringInternalModel !== stringRealDefaultValue && this.internalModel !== null) {
                    this.maskedModel = Inputmask.format(this.internalModel, this.mask)
                } else {
                    this.maskedModel = null
                }
            } else {
                if (this.internalModel !== null) {
                    if (this.nullable || (!this.nullable && stringInternalModel !== stringRealDefaultValue)) {
                        this.maskedModel = Inputmask.format(this.internalModel, this.mask)
                    } else {
                        this.maskedModel = null
                    }
                } else {
                    this.maskedModel = null
                }
            }
            // if (!this.touched || this.internalModel !== this.realDefaultValue) {
            //     if (this.internalModel !== null) {
            //         this.maskedModel = Inputmask.format(this.internalModel, this.mask)
            //     } else {
            //         this.maskedModel = null
            //     }
            // } else {
            //     this.maskedModel = null
            // }
        },
        changed (newVal) {
            // const oldInternalModel = this.internalModel
            // const oldModel = this.model

            const newInternalModel = filter(this.mask, newVal, this.defaultValue, this.nullable)
            const newModel = filterOrDefault(this.mask, newVal, this.defaultValue, this.nullable)

            // console.log("changed", this.fieldName, { init: this.initialModel, oldInternalModel, oldModel, newInternalModel, newModel})

            // this.touched = true
            if (newModel === this.initialModel) {
                this.touched = false
            } else {
                this.touched = true
            }

            this.internalModel = newInternalModel
            this.controlledModel = newModel
            this.model = newModel

            this.doMask()
        },
        fakeInputFocused () {
            this.display = true
            this.$nextTick(() => this.$els.input.focus())
        }
    },
    watch: {
        model (_newVal, _oldVal) {
            // trace(`watch model ${this.fieldName}`, { isSetup: this.isSetup, _newVal, _oldVal })

            if (!this.isSetup) {
                return
            }

            if (_newVal !== this.controlledModel) {
                this.boot(_newVal)

                this.doMask()

                this.$els.input.value = _newVal
            }
        }
    },
    computed: {
        placeholderText () {
            return this.placeholder || null
        },
        fakeStyle () {
            return {
                textAlign: isRTL(this.mask) ? 'right' : 'left',
                display: this.display ? 'none' : 'block'
            }
        }
    },
    template: `
            <div class="form-group">
                <form-label v-if="hasLabel()" :hint="getHint()">
                    <slot name="label">
                        {{ label }}
                    </slot>
                </form-label>
                <div v-bind:class="holderClass()">
                    <i v-bind:class="iconClass" v-if="iconClass"></i>
                    <div v-bind:class="inputHolderClass()">
                        <input type="text"
                            v-bind:id="'fake-' + fieldId"
                            class="fake-mask-input"
                            v-bind:class="inputClass"
                            v-bind:placeholder="placeholderText"
                            v-bind:data-field="fieldName"
                            v-model="maskedModel"
                            @focus="fakeInputFocused"
                            :disabled="!isSetup || disabled"
                            :style="fakeStyle" />
                        <input type="text"
                                v-bind:id="fieldId"
                                class="mask-input"
                                v-bind:class="inputClass"
                                v-bind:placeholder="placeholder"
                                v-bind:data-field="fieldName"
                                v-bind:disabled="disabled"
                                v-el:input
                                @blur="_onBlur"
                                @keydown="_onKeyDown"
                                :disabled="!isSetup || disabled"
                                :style="{'display': display ? 'block' : 'none'}">
                        <slot name="append"></slot>
                    </div>
                </div>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/mask.js